import * as React from 'react';
import {RemoteBlob} from './remote-blob';

export const RemoteImage = (props) => {
  const {children, ...rest} = props;

  return (<RemoteBlob {...rest}>
      {({ objectUrl, error }) =>
        error || !objectUrl ? <div className="image-loading"/> :
          children ? children(objectUrl) : <img className="img-fluid" src={objectUrl} />
      }
  </RemoteBlob>);
};
